import { useQuery } from '@tanstack/react-query';

import { getAccessToken } from 'utils';

import { fetchUserInfoApi } from '../api';

/*
 * Defaults to the session cookie, because the cache does not outlive the tab
 * and the session does. Called with nothing, this used to sit disabled forever
 * and only login ever filled the cache by hand, so a reload left the sidebar
 * with just the items hardcoded into the nav and none of the ones the server
 * sends.
 */
const useUserQuery = (accessToken = getAccessToken()) =>
  useQuery(['users'], fetchUserInfoApi, {
    enabled: !!accessToken,
    staleTime: Infinity,
  });

export default useUserQuery;
